import { render, staticRenderFns } from "./news_stories.vue?vue&type=template&id=6e2cfad8&scoped=true"
import script from "./news_stories.vue?vue&type=script&lang=js"
export * from "./news_stories.vue?vue&type=script&lang=js"
import style0 from "./news_stories.vue?vue&type=style&index=0&id=6e2cfad8&prod&lang=css"
import style1 from "./news_stories.vue?vue&type=style&index=1&id=6e2cfad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2cfad8",
  null
  
)

export default component.exports